// Mapa local com os valores de salário mínimo por ano
// Observação: usar temporariamente até existir integração com backend oficial
const SALARIO_MINIMO_MAP = {
  2020: 1045.0,
  2021: 1100.0,
  2022: 1212.0,
  2023: 1320.0,
  2024: 1412.0,
  2025: 1502.0,
};

// Retorna o valor do salário mínimo com base no ano informado
export function getSalarioPorAno(ano) {
  const a = Number(ano);
  if (!Number.isFinite(a)) return null;
  return SALARIO_MINIMO_MAP[a] ?? null;
}

// Retorna a lista de anos disponíveis no mapa de salário mínimo
export function getAnosDisponiveis() {
  return Object.keys(SALARIO_MINIMO_MAP)
    .map((x) => Number(x))
    .sort((a, b) => a - b);
}

// Exporta o mapa completo de salário mínimo para uso em outras partes do sistema
export default SALARIO_MINIMO_MAP;
